import type { FC } from 'react';
import { Button, Result } from 'antd';
import AppLayout from 'packages/lib/common-ui/app-shell/app-layout';
import { Link } from 'react-router-dom';

interface Error404Props {
  subTitle?: string;
  show404Code?: boolean;
}

export const Error404Result: FC<React.PropsWithChildren<Error404Props>> = ({
  subTitle = 'The page you requested cannot be found.',
  show404Code = true,
}) => (
  <Result
    status="404"
    title={show404Code ? '404' : undefined}
    subTitle={subTitle}
    extra={
      <Link
        to={
          window.location.origin +
          window.location.pathname.includes('contractor')
            ? '/contractor'
            : ''
        }
      >
        <Button role="link" type="primary">
          Back Home
        </Button>
      </Link>
    }
  />
);
export const ErrorPage404: FC<React.PropsWithChildren<unknown>> = () => (
  <AppLayout>
    <Error404Result />
  </AppLayout>
);

export default ErrorPage404;
